import fields from '@src/entities/ActionPath/includes/fields.json';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';
import React from 'react';

const { exitCriteriaMethod: exitCriteriaMethodField } = fields;

/**
 * Field: ExitCriteriaMethod
 *
 * Select what defines the action path as resolved/completed.
 *
 * @param isActiveAndManual
 * @returns {Element}
 * @constructor
 */
export function ExitCriteriaMethod({ isActiveAndManual }) {
  return (
    <ErrorHandler location="src/features/ActionPaths/Wizard/components/fields/ExitCriteriaMethod/ExitCriteriaMethod.jsx">
      <SelectInput isDisabled={isActiveAndManual} {...exitCriteriaMethodField} css={{ width: 'auto' }} />
    </ErrorHandler>
  );
}
